import {
    HeadSectionContent,
    SectionsTitleText,
} from "../../models/common/common";
import {
    ContactsInfo,
    GenericContact,
    IContactData,
} from "../../models/contact";
import colors from "../../styles/colors.module.scss";

const headTitle: SectionsTitleText[] = [
    {
        text: "We’re here for you every step of the way",
        color: colors.textWhiteLight,
        fontWeight: "fw-bold",
        newLine: true,
    },
];

export const emptyGenericContact: GenericContact = {
    calendlyUri: "",
    telegram: "",
    whatsapp: "",
    whatsappPrefix: "",
    title: "",
    subtitle: "",
    calendlyTitle: "", // Testo di fallback per Calendly
};

export const getContactsInfo = (
    contacts: Partial<IContactData>
): ContactsInfo[] => [
    // PRIMA CARD: INFORMAZIONI GENERALI
    // Per clienti che hanno domande sui viaggi prima della prenotazione
    {
        id: "info",
        title: contacts.helpContacts?.title
            ? contacts.helpContacts?.title
            : "You're still not sure of how our trips work?",
        description: contacts.helpContacts?.subtitle
            ? contacts.helpContacts?.subtitle
            : "Don't worry, we're here to help. Feel free to contact us by phone or e-mail.",
        number: contacts?.infoPhone || "",
        email: contacts?.infoEmail || "",
        phoneTitle: contacts?.infoPhoneTitle,
        emailTitle: contacts?.infoEmailTitle,
        contacts: contacts?.helpContacts || emptyGenericContact,
    },
    // SECONDA CARD: ASSISTENZA PRENOTAZIONI - DISABILITATA
    // Per clienti che hanno già prenotato e hanno bisogno di assistenza
    // {
    //     id: "book",
    //     title: contacts.bookingContacts?.title
    //         ? contacts.bookingContacts?.title
    //         : "Do you need clarifications on your booking?",
    //     description: contacts.bookingContacts?.subtitle
    //         ? contacts.bookingContacts?.subtitle
    //         : "If you need any assistance or if you have any doubts regarding your trip, we're here to help.",
    //     number: contacts?.bookPhone || "",
    //     email: contacts?.bookEmail || "",
    //     contacts: contacts?.bookingContacts || emptyGenericContact,
    // },
    // TERZA CARD: FEEDBACK POST-VIAGGIO - DISABILITATA
    // Questa card è dedicata ai clienti che hanno già viaggiato con Play Italy
    // e vogliono condividere la loro esperienza o suggerimenti
    // {
    //     id: "feedback",
    //     title: contacts.feedbackContacts?.title
    //         ? contacts.feedbackContacts?.title
    //         : "Have you already traveled with us? Give us some feedback!",
    //     description: contacts.feedbackContacts?.subtitle
    //         ? contacts.feedbackContacts?.subtitle
    //         : "We'd love to hear from you even after your trip. Tell us what you liked the most or what would you improve.",
    //     // Contatti specifici per il feedback (telefono e email dedicati)
    //     number: contacts?.feedbackPhone || "",
    //     email: contacts?.feedbackEmail || "",
    //     // Contatti aggiuntivi dal CMS (WhatsApp, Calendly, ecc.)
    //     contacts: contacts?.feedbackContacts || emptyGenericContact,
    // },
];

const headSubTitle: SectionsTitleText[] = [
    {
        text: "",
        color: colors.textWhiteLight,
        fontWeight: "fw-bold",
        newLine: false,
    },
];

export const headData: HeadSectionContent = {
    backgroundImageUrl:
        "https://images.unsplash.com/photo-1633613286848-e6f43bbafb8d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    title: headTitle,
    subTitle: headSubTitle,
};
